<template>
    <tr>
        <td>
            <div class="color_select" :style="getSelectedPaletteColorStyle(state.paletteIndex)"
                 @click="showPaletteSelectOverlay" @click.stop="showPaletteSelectOverlay">
                <div class="color_select_overlay" v-if="isShowPalette" v-clickoutside:hidePaletteSelectOverlay>
                    <div v-for="(color, index) in basicPalette" :key="index">
                        <div class="color_select" :class="{'selected': index == state.paletteIndex}"
                             :style="getPaletteColorStyle(index)" @click="selectColor(index)"></div>
                    </div>
                </div>
            </div>
        </td>
        <td>
            <input type="text" class="input_s w_full" :placeholder="$t('reservation_settings.section_appointment_status_management.placeholder_appointment_status')" :value="state.title"
                   @input="changeStateTitle($event.target.value)">
        </td>
        <td>
            <label class="check_wrap">
                <input type="checkbox" :disabled="state.isDefault && state.isCancelStatus" v-model="state.isVisitStatus"
                       @change="updateVisitStatus()">
                <span class="checkmark"></span>
                {{ $t('reservation_settings.section_appointment_status_management.label_display_as_visit') }}
            </label>
        </td>
        <td>
            <div class="btn_group">
                <button class="btn btn_xs btn_lgray_line" :disabled="index == 0" @click="handlerMoveToFirst()">
                    <v-icon>mdi-chevron-double-up</v-icon>
                </button>
                <button class="btn btn_xs btn_lgray_line" :disabled="index == 0" @click="handlerMoveToPrevious()">
                    <v-icon>mdi-chevron-up</v-icon>
                </button>
                <button class="btn btn_xs btn_lgray_line" :disabled="index == (states.length - 1)"
                        @click="handlerMoveToNext()">
                    <v-icon>mdi-chevron-down</v-icon>
                </button>
                <button class="btn btn_xs btn_lgray_line" :disabled="index == (states.length - 1)"
                        @click="handlerMoveToLast()">
                    <v-icon>mdi-chevron-double-down</v-icon>
                </button>
            </div>
        </td>
        <td class="txt_center" v-if="!isDefault">
            <button class="btn btn_s btn_dgray" @click="removeItem()">－ {{ $t('common.delete') }}</button>
        </td>
        <td class="txt_center" v-if="isDefault && !isCancelStatus">{{ $t('reservation_settings.section_appointment_status_management.label_default') }}</td>
        <td class="txt_center" v-if="isDefault && isCancelStatus">{{ $t('reservation_settings.section_appointment_status_management.label_cancel_appt') }}</td>
    </tr>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import { SpaceNavigationAction } from '../Enums/SpaceNavigationAction.js'

export default {
    props: {
        item: Object,
        index: Number,
        states: Array,
        basicPalette: Array
    },
    data() {
        return {
            isShowPalette: false,
            state: {}
        }
    },
    watch: {
        item: {
            immediate: true,
            deep: true,
            handler: function (newValue) {
                this.state = deepCopy(newValue)
            }
        }
    },
    computed: {
        isDefault: function () {
            return this.state.isDefault ?? false
        },
        isCancelStatus: function () {
            return this.state.isCancelStatus ?? false
        }
    },
    methods: {
        getSelectedPaletteColorStyle(index) {
            let color = this.basicPalette[index]
            if (!color) { return '' }
            return `background-color: ${ color }`
        },
        getPaletteColorStyle(index) {
            let color = this.basicPalette[index]
            if (!color) { return '' }
            return `background-color: ${ color }`
        },
        selectColor(index) {
            this.state.paletteIndex = index
            this.hidePaletteSelectOverlay()
            this.$emit('updateItem', this.state, this.index)
        },
        changeStateTitle(value) {
            this.state.title = value
            this.$emit('updateItem', this.state, this.index)
        },
        updateVisitStatus() {
            this.$emit('updateItem', this.state, this.index)
        },
        removeItem() {
            this.$emit('removeItem', this.index)
        },
        handlerMoveToFirst() {
            this.$emit('updateOrder', SpaceNavigationAction.FIRST, this.index)
        },
        handlerMoveToNext() {
            this.$emit('updateOrder', SpaceNavigationAction.NEXT, this.index)
        },
        handlerMoveToPrevious() {
            this.$emit('updateOrder', SpaceNavigationAction.PREVIOUS, this.index)
        },
        handlerMoveToLast() {
            this.$emit('updateOrder', SpaceNavigationAction.LAST, this.index)
        },
        showPaletteSelectOverlay() {
            this.$emit('hideColorPalette', this.index)
            this.isShowPalette = true
        },
        hidePaletteSelectOverlay() {
            this.isShowPalette = false
        },
    }
}
</script>